import * as React from 'react'

import {
    Box,
} from '@mui/material'
import { NossaSolucao } from './nossaSolucao'
import { NossosNumeros } from './nossosNumeros'
import { CarrouselParceiros } from './carrouselParceiros'
import { CarrouselClientes } from './carrouselClientes'
import { CarrouselClientesFalam } from './carrouselClientesFalam'
import { NossosProdutos } from './nossosProdutos'
import { Orcamento } from './orcamento'

const Middle: React.FC = () => {

    return (
        <Box>
            <div title='nossol'>
                <NossaSolucao/>
            </div>
            <div title='num'>
                <NossosNumeros />
            </div>
            <div title='prod'>
                <NossosProdutos />
            </div>
            <div style={{
                backgroundColor: "white"
            }}>
                <div title='parc'>
                    <CarrouselParceiros />
                </div>
                <div title='cli'>
                    <CarrouselClientes />
                </div>
                
            </div>
            
            <div title='dep' style={{ display: "flex", justifyContent: "center" }} >
                <CarrouselClientesFalam />
            </div>
            <div title='orc'>
                <Orcamento />
            </div>
        </Box>
    );
}

export { Middle }